var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:[_vm.color, _vm.color !='' ? 'white--text': '']},[_vm._v(_vm._s(_vm.valor == "1" ? 'SI' : 'NO'))])])}
var staticRenderFns = []

export { render, staticRenderFns }